import "react-datepicker/dist/react-datepicker.css";
import DatePickerReact from "react-datepicker";

// Fonction pour convertir "YYYY-MM-DD" en Date
const parseDateFromInput = (value: string | null): Date | null => {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
    return new Date(year, month - 1, day);
  }
  return null;
};

// Fonction pour formater une Date en "YYYY-MM-DD"
const formatDateToInput = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

interface MonthYearInputProps {
  label: string;
  name: string;
  value: string | null; // Maintenant au format "YYYY-MM-DD"
  onChange: (date: string | null) => void;
  disabled?: boolean;
  className?: string;
}

export function YearPicker({
  label,
  name,
  value,
  onChange,
  disabled,
  className,
}: MonthYearInputProps) {
  const parsedDate: Date | null = parseDateFromInput(value);

  return (
    <div className={`flex flex-col text-grey ${className}`}>
      <label className="3xl:text-md text-sm font-thin">{label} :</label>
      <DatePickerReact
        selected={parsedDate}
        onChange={(date: Date | null) => {
          if (date) {
            const firstDayOfMonth = new Date(
              date.getFullYear(),
              date.getMonth(),
              1
            );
            const formattedDate = formatDateToInput(firstDayOfMonth); // => "YYYY-MM-DD"
            onChange(formattedDate);
          } else {
            onChange(null);
          }
        }}
        name={name}
        disabled={disabled}
        dateFormat="yyyy"
        showYearPicker
        className={`bg-white shadow-lg border-light-blue border-2 rounded-md 3xl:p-2 p-1 mt-1`}
      />
    </div>
  );
}
